import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { post } from '../../services/api'
import mmLogo from '../../assets/img/mmlogo.svg'
import imgPasswordVisible from '../../assets/img/password.svg'
import imgPasswordHidden from '../../assets/img/password-hidden.svg'
import '../../app.css'
import './LoginPage.css'
import { TailSpin } from "react-loader-spinner";
import jwtDecode from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { tryAuthenticateViaCookie } from '../../auth';

function LoginPage({ onLogin, manutencao = false, }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [cookies, setCookie] = useCookies(['mmauthjwt']);
  const usernameInputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (manutencao) {
      usernameInputRef?.current?.focus();
      return;
    }

    const checkCookieAuth = async () => {
      const authenticated = await tryAuthenticateViaCookie(true);
      if (authenticated) {
        navigate("/");
      }
    };
    
    checkCookieAuth();
    usernameInputRef?.current?.focus();
  }, [navigate, manutencao]);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (sessionStorage.getItem('manual_logout') === 'true') {
      sessionStorage.removeItem('manual_logout');
    }
  };

  const handleLogin = async () => {
    try {
      const hostname = getHostName();

      if (username == '' || password == '') {
        return setError("Informe o usuário e a senha!");
      }

      const removedFormatUsername = username.replace(/[.-]/g, '');

      if (removedFormatUsername.length < 11) {
        return setError("O CPF deve conter 11 caracteres!");
      }

      const requisicao = { cpf: removedFormatUsername, senha: password, hostname: hostname }

      setIsFetchingData(true);
      
      const response = await post('/login/autenticacao', requisicao);

      setIsFetchingData(false);

      if (response.loginValido === true) {
        
        const jwtDecoded = jwtDecode(response.jwt);

        const idDepartamentoUsuario = jwtDecoded.legacy_roles.id_departamento;

        const idVendedorUsuario = jwtDecoded.legacy_roles.vendedor;

        const idUsuario = jwtDecoded.legacy_roles.idusuario;

        // Se usuario tiver login autorizado, pode entrar no sistema
        if (response.loginAutorizado === true) {
          onLogin(removedFormatUsername);
          
          sessionStorage.removeItem('manual_logout');
          sessionStorage.setItem('just_logged_in', 'true');

          localStorage.setItem('token', response.jwt);
          localStorage.setItem('usuariologado', response.nome);
          localStorage.setItem('idfilialusuario', response.filial);
          localStorage.setItem('nomefilialusuario', response.nomefilial);
          localStorage.setItem('idvendedorusuario', idVendedorUsuario);
          localStorage.setItem('iddepartamentousuario',idDepartamentoUsuario);
          localStorage.setItem('idusuario', idUsuario)
          localStorage.setItem('adminToken', response.adminToken);
          localStorage.setItem('userToken', response.userToken);
          localStorage.setItem('last_jwt_cookie', response.jwt);

          const expirationTimestamp = jwtDecoded.exp;
          const expirationDate = new Date(expirationTimestamp * 1000);

          setCookie('mmauthjwt', response.jwt, { path: '/', expires: expirationDate, domain: '.lojasmm.com.br' });
          
          navigate("/"); // Redirecionar para a página inicial após o login
        } else {
          setError("Usuário não autorizado!");  
        }
      } else {
        setError("Usuário ou senha incorretos!");
      }
    } catch (error) {
      setIsFetchingData(false);
      setError("Erro ao fazer login. Tente novamente mais tarde!");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLogin();
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  function getHostName() {
    /* eslint-disable no-restricted-globals */
    const canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");
    var txt = "MMFingerprint";

    ctx.textBaseline = "top";
    ctx.font = "17px 'Arial'";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#059";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    let fingerprint = canvas.toDataURL();
    fingerprint += window.navigator.platform;
    fingerprint += window.navigator.userAgent;
    fingerprint += screen.width;
    fingerprint += screen.height;
    fingerprint += window.devicePixelRatio;

    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      let char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }

    return hash;
    /* eslint-enable no-restricted-globals */
  }

  return (
    <section className="bg-[url(../img/bg-login.svg)] bg-cover bg-no-repeat bg-center supports-[height:100dvh]:h-[100dvh] h-screen grid place-items-center">
      <div className="bg-white rounded-lg shadow-[0px_18px_13px_-10px_#C8C8C8B2] w-[90%] md:w-[31rem] py-6 px-8 md:px-20">
        <div className="text-center">
          <img src={mmLogo} alt="Logo da MM" className="object-contain w-56 inline-block" />
          <h1 className="font-poppins text-lg font-semibold text-gray-c23 py-4">Painel de Excelência</h1>
          {manutencao 
            ? <div>
                <p className="mb-2"><b>Sistema em manutenção</b></p>
                <p>Estamos realizando melhorias no sistema. Em breve ele estará disponível novamente.</p>
            </div>
            : <div className="font-mulish text-base font-normal text-gray-c24 text-left">
            <label className="block mb-1.5">CPF <span className="text-red-c1">*</span></label>
            <input type="text" maxLength={14} minLength={14}
              value={username}
              onChange={handleUsernameChange}
              name="email"
              id="email"
              placeholder="Digite seu CPF"
              required
              className="block w-full border border-gray-c20 rounded-[3px] placeholder:text-gray-c25 mb-5"
              onKeyPress={handleKeyPress}
              ref={usernameInputRef} />
            <label className="block mb-1.5">Senha <span className="text-red-c1">*</span></label>
            <div className="relative">
              <input
                type={passwordVisible ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                name="password"
                id="password"
                placeholder="Digite sua senha do Web Vendas"
                required
                className="block w-full border border-gray-c20 rounded-[3px] placeholder:text-gray-c25 mb-3"
                onKeyPress={handleKeyPress}
              />
              <button
                type="button"
                className="absolute right-2 top-1/2 -translate-y-1/2"
                onClick={togglePasswordVisibility}
              >
                <img
                  src={passwordVisible ? imgPasswordVisible : imgPasswordHidden}
                  alt="Olho"
                />
              </button>
            </div>
            <div className="text-center">
              <button onClick={handleLogin} className="bg-red-c1 font-bold text-base text-white rounded-[68px] py-2.5 w-full md:w-[55%] mt-4" disabled={isFetchingData}>
                {isFetchingData ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <TailSpin color="#ffffff" height={24} width={39} />
                  </div>
                ) : (
                  "Login"
                )}
              </button>
            </div>

          </div> 
          }
          {error && <p className="text-red-c1">{error}</p>}
        </div>
      </div>
    </section>

  );


}

export default LoginPage;